export default {
    site: {
        common: {
            hello: "hallo",
            thankYou: "danke",
            forMoreInfo: "für weitere Informationen",
            hoverOverColumnHeaders: "Fahre mit der Maus über die Spaltenüberschriften, um weitere Informationen zu erhalten.",
            username: "Benutzername",
            score: "Punktestand",
            points: "Punkte",
            pointsAbbreviation: "Pkt",
            chapter: "Kapitel",
            tier: "Kategorie",
            t1: "K1", //Kat1?
            t2: "K2", //Kat2?
            t3: "K3", //Kat3?
            collectionsPerDay: "Einsammlungen pro Tag",
            relicBoostPercent: "Reliktbonus %",
            mountainHallPercentShort: "Gebirgsh. %", // used in table heading keep it short. >>> Geb.-Hallen?
            updated: "aktualisiert",
            lastUpdated: "zuletzt aktualisiert",
            created: "erstellt",
            role: "Status", //Rang?
            Fellow: 'Gefährte',
            Ambassador: 'Botschafter',
            Mage: 'Großmagier',
            Archmage: 'Erzmagier',
            saveChanges: "Änderungen übernehmen",
            copy: "kopieren",
            close: "schließen",
            cancel: "abbrechen",
            action: "Aktion",
            date: "Datum",
            Left: "ausgetreten",
            Joined: "beigetreten",
            human: "Mensch",
            elf: "Elf",
            search: "suche",
            enter: "eingeben", //Enter?
            yes: "ja",
            no: "nein",
            tournament: "Turnier",
            tournaments: "Turniere",
            fellowship: "Gemeinschaft",
            player: "Spieler",
            member: "Mitglied",
            history: "Historie",
            tournamentHistory:  "Turnier-Historie",
            scoreHistory: "Punktestand-Historie",
            server: "Server",
            lastWeekGain: "Zuwachs letzte Woche",
            comingSoon: "demnächst",
            chest: "Kiste",
            yourServer: "dein Server",
            allServers: "alle Server",
            boosts: "Bonusgüter",
            marble: "Marmor",
            steel: "Stahl",
            planks: "Holz",
            crystal: "Kristall",
            scrolls: "Schriftrollen",
            silk: "Seide",
            elixir: "Elixier",
            magic_dust: "Magiestaub",
            gems: "Edelsteine",
            sentient: "erweckte",
            goods: "Güter",
            average: "Durchschnitt",
            expansions: 'Erweiterungen', // 5x5 grids
            cultureBoostMinimum: 'niedrigster Kulturbonus', //kleinster/niedrigster Kulturbonus?
            cultureBoostCalculated: 'errechneter Kulturbonus',
            neighborlyHelp: 'Nachbarschaftshilfe',
            neighborlyHelpAbbreviation: 'NBH'
        },
        // HIGH PRIORITY
        nav: {
            home: "Startseite",
            players: "Spieler",
            fellowships: "Gemeinschaften",
            tournaments: "Turniere",
            contact: "Kontakt",
            donate: "Spenden",
            faq: "FAQ",
            news: "Neuigkeiten",
            privacyPolicy: "Datenschutz",
            me: "Ich",
            myFellowship: "Meine Gemeinschaft",

            // NOTE USED AT THE MOMENT
            globalStats: "Globale Statistiken",
            articles: "Artikel", //Beiträge?
            fellowshipAdventure: "Gemeinschaftsabenteuer",
            recruit: "rekrutieren", //Rekrut?; Rekrutierungen?
        },
        // VERY HIGH PRIORITY!
        elvenArchitect: {
            viewCityOnElvenArchitect: "Stadt auf ElvenArchitect ansehen."
            ,obtainingLink: "fordere Link an"
            ,successMessage: "Erfolgreich! Klicke auf den unten stehenden Link, um ElvenArchitect aufzurufen."
            ,ageOfLink: "Oben stehender Link zeigt die Stadt, wie sie war: "
            ,clickToGetCurrentCity: "<-- Klicke hier, um eine aktuelle Version der Stadt zu sehen.",
        },
        // High Priority
        playerSelection: {
            headline: "Seite betrachten als",
            description: "Dadurch aktualisieren sich verschiedene Bereiche der Website, die an den Seitenbenutzer angepasst sind.  Beispiele hierfür sind: Meine Gemeinschaft, mein Benutzer (Ich), Turniere und Ranglisten.", //Ranglisten?
            youAreViewing: `Du betrachtest die Seite nun als {username} auf {serverName}.`,
            changeUser: "Benutzer wechseln",
            enterYourUsernameToGetStarted: "Gib deinen Elvenar-Benutzernamen ein, um loszulegen",
            thisIsNotASignup:"Dies ist kein Registrierungsvorgang.  Durch die Eingabe deines Benutznamens passen wir lediglich die Seite dementsprechend an.  Es gibt zahlreiche Elvenar-Server und wir wollen die Ranglistenergebnisse für deinen Server anzeigen.  Ebenso werden die Reiter 'Meine Gemeinschaft' und 'Ich' verfügbar."
        },
        searchBoxes: {
            enterFellowshipName: 'Gemeinschaftsnamen eingeben',
            instructions: "Namen eingeben und auswählen.",
            noFellowship: "Keine Gemeinschaft",
        },
        relativeTime: {
            // Relative time strings - note: these aren't yet implemented in the code
            daysAgo: "Tage zuvor",
            minsAgo: "Minuten zuvor", //shorter? > Min. zuvor
            hoursAgo: "Stunden zuvor", //shorter? > Std. zuvor
            justNow: "gerade eben",
            never: "niemals",
        },
        home: {
            welcome: "Willkommen bei Elven Stats!",
            youAreViewing: "Du betrachtest die Seite nun als {username} auf {serverName}.",
            youCanChange: "Du kannst den Benutzer ändern, indem du auf den Avatar in der oberen rechten Ecke klickst -oder- indem du <router-link to='/contact'>hier klickst</router-link>",
            features: {
                headline: "Funktionen",
                fellowshipAdministration: {
                    headline: "Administration der Gemeinschaft <strong>EINFACH GEMACHT</strong>",
                    bullet1: "Automatische Erfassung der Bonusgüter, damit du deine Gemeinschaft ins Gleichgewicht bringen kannst",
                    bullet2: "Automatische Erfassung/Generierung von wöchentlichen E-Mail-Reports einschließlich Punkten, Turnierteilnahme, monatlichem Wachstum & motivierenden \"Auszeichnungen\" und persönlichen Bestleistungen",
                    bullet3: "Erkennung von unausgewogenen Produktionen der Gemeinschaftsmitglieder von z.B. Vorräten oder Bonusgütern",
                },
                elvenArchitectIntegration: {
                    headline: "ElvenArchitect <strong>Einbindung</strong>",
                    description: "Importiere deine Stadt innerhalb von Sekunden eins-zu-eins nach ElvenArchitect! Nutze dies, um die nächste große Neugestaltung deiner Stadt zu planen oder um Platz zu finden, von dem du gar nicht wusstest, dass es ihn gibt! Halte auf den Spielerseiten nach dem Logo von ElvenArchitect Ausschau."
                },
                advancedRankingLists: {
                    headline: "Erweiterte <strong>Ranglisten</strong>",
                    bullet1: "Rangliste nach freigeschalteten Bereichen (um dich mit Leuten mit ähnlichem Fortschritt zu vergleichen)",
                    bullet2: "Schaue dir Boni, Kapitelnummer und mehr in Ranglisten an.",
                },
                fellowshipTournamentTracking: {
                    headline: "Turnier-<strong>Rangliste</strong>",
                    description: `Schaue, wie sich deine Gemeinschaft gegen andere schlägt. Fordere andere Gemeinschaften zu einem 
                    freundschaftlichem Wettkampf heraus!`,
                },
                matchMaking: {
                    headline: "<strong>Spielersuche</strong>",
                    description: `ElvenStats erfasst Spielerboni und das Verhältnis der Güterproduktion von Gemeinschaften.  Mit diesen 
                    Informationen ist es Gemeinschaften möglich, die passenden Kandidaten zu finden, um das Gütergleichgewicht zu halten. Benutzer,
                        die nach einer Gemeinschaft Ausschau halten, können so gezielt nach Gemeinschaften suchen, die die Bonusgüter tatsächlich BENÖTIGEN.
                        Spare Zeit und reduziere Absagen!`
                }
            }
        },
        fellowship: {
            stats: {
                rank: "Rang",
                points: "Punkte",
                medianUserScore: "Ø <strong>Spielerpunktestand</strong>",
                memberCount: "<strong>Anzahl</strong> der Mitglieder",
            },
            barCharts: {
                clickSlice: "Für Details, klicke auf eine der Säulen (pro Mitglied)",
                tier1: "Kategorie 1",
                tier2: "Kategorie 2",
                tier3: "Kategorie 3",
                drillDown: "zurück zu {0}"
            },
            idealCandidate: {
                heading: "Optimaler Kandidat",
                description: "Würde etwa eine Punktzahl von {medianScore} haben und eines oder mehrere der folgenden Bonusgüter besitzen: {boosts}",
                note: "Einige Kombinationen der Bonusgüter sind nicht möglich. Siehe hier, {0}"
            },
            memberGoodsTable: {
                heading: "Güterproduktion der Mitglieder",
                description: `Diese Tabelle berechnet, wie viel deine Gemeinschaft von jedem Gut produziert. Wir haben gründlich überlegt, wie hoch 
                die Prozentsätze deiner Mitglieder sind und gehen standardmäßig davon aus, dass jedes Mitglied 3 Einsammlungen pro Tag macht (2x9std 
                und 1x3std). Um die Genauigkeit zu erhöhen, frage deine Gemeinschaftsmitglieder nach ihren tatsächlichen Werten und trage 
                sie unten ein. Du kannst die Eingaben speichern, damit sie beim nächsten Seitenaufruf zu sehen sind. Die oben stehenden 
                Balkendiagramme werden automatisch aktualisiert, nachdem du die Veränderungen vorgenommen hast. Fahre mit der Maus über die 
                Spaltenüberschriften, um weitere Informationen zu einer speziellen Spalte zu erhalten.
                `,
                refreshButtonText: 'Aktualisiere die Mitgliederliste',
                refreshButtonTip: `Dies wird neue Mitglieder hinzufügen, alte Mitglieder entfernen, Status der Gemeinschaft und aktuelle Punktestände 
                aktualisieren.`,
                inactiveWarningTip: `Benutzer möglicherweise inaktiv, Punktestand zuletzt aktualisiert: {0}',
                    collectsPerDayValidation: "Muss zwischen 1-6 liegen`,
                boostPercentValidation: "Muss zwischen 40-700 liegen, Bonus der Gebirgshallen nicht inbegriffen",
                perDayShort: "/Tag",

                // HIGH PRIORITY - IMPORTANT TOOLTIPS
                scoreTip: "Der Punktestand des Spielers; bitte beachte, dass dieser nicht in Echtzeit aktualisiert wird.  Er wird mehrmals pro Woche aktualisiert.",
                chapterTip: "Dies ist das Kapitel, indem sich der jeweilige Spieler befindet.  Zur Orientierung: Elementare = 12, Halblinge = 11, etc.",
                boostTip: "Die Boni der Spieler und die PRODUZIERTE Menge pro Tag.",
                collectsPerDayTip: `***EDITIERBAR*** <br/>Einsammlungen pro Tag. Dies ist die Anzahl, wie oft ein Spieler Güter von ihren 
                Manufakturen einsammelt. Es sollte ein Wert zwischen 1-6 haben.  1 = 1x24std, 2 = 2x9std, 3 = 2x9std + 1x3std, 4 = 1x9std + 3x3std, 
                5 = 4x3std + 1x9std, 6 = 5x3std + 1x9std<BR/>Bitte lies für weitere Informationen die FAQ.`,
                relicBoostPercentTip: `***EDITIERBAR***<br/>Der Bonus durch Relikte liegt zwischen 40-700.  Es sollte nicht den Bonus der 
                Gebirgshallen beinhalten.  Dies wird automatisch erkannt und zu dieser Zahl hinzugefügt`,
                mountainHallPercentTip: `Dies ist der Bonus der Gebirgshallen, den wir für diesen Benutzer erkannt haben.  Er wird in Verbindung mit 
                den Prozenten der Bonusgüter verwendet, um den Gesamt-Prozentsatz zu berechnen.`,
                updatedTip: `Hier steht, wann die Stadt des Spielers das letzte Mal analysiert wurde.  Dieser Vorgang bestimmt die Boni, Daten für 
                ElvenArchitect, berechnet die Produktionen aller Manufakturen, Bonus der Gebirgshallen und mehr. Stadtplandaten werden regelmäßig
                automatisch erfasst aber man kann eine Aktualisierung erzwingen, indem man auf den unten befindlichen Aktualisierungsbutton
                klickt.`,

            },
            coinsAndSuppliesTable: {
                heading: "Münz-/Vorräte-Produktion",
                description: `Die Hauptspalte hier ist "Vorräte übrig" die anzeigt, ob ein Mitglied genügend Vorräte produziert, um seine 
                Manufakturen 24/7 zu beschäftigen.  Benutze die unten befindlichen Kippschalter, um den niedrigsten Kulturbonus des Spielers in die 
                Berechnung einfließen zu lassen (das ist der Boost, den du hast, wenn du keine Nachbarschaftshilfe erhalten würdest) und/oder die 
                Anzahl, wie oft das Mitglied Produktionen einsammelt (wie in der Güter-Tabelle angegeben). Beides zu deaktivieren ist nützlich, 
                um zu sehen, wie viele der Vorräte für die Produktionen in den Manufakturen verbraucht werden oder man durch einen höheren 
                Kulturbonus erhält. Bitte beachte abschließend, dass es üblich ist, einen negativen Wert (~10% des Gesamtwertes) bei "Vorräte übrig" 
                zu haben. Es gibt viele Wege, wie Spieler ihr Vorräte aufstocken, wie z.B. mit Nachbarschaftshilfe, Vorräte in schnelleren Intervallen 
                produzieren (Getränke, Einfache Werkzeuge, Brot...) oder durch das Einsetzen von Verzauberte-Vorräte-Zaubern.
                Betrachte den negativen Wert als das, was du täglich nachholen musst, indem du eine dieser Möglichkeiten nutzt.
                Beachte: im Moment wird die Truppenproduktion nicht mit in die benötigten Vorräte einberechnet (nur Güter der Kategorie 1, 2 und 
                3) also könnte es sein, dass du mehr benötigst.`,

                // These are the column text that show up under the icons. Keep them short.
                minBoostPercent: "min K.-Bonus %",
                made: "produziert",
                used: "benötigt",
                left: "übrig",

                // Low Priority TOOL TIPS
                minimumCultureBoostPercent: `Der Kulturbonus-Prozentsatz.  WICHTIG: dieser wird in der Annahme berechnet, dass KEINE 
                    NACHBARSCHAFTSHILFE erhalten wurde. In Wirklichkeit wird der Kulturbonus in den Städten aber voraussichtlich höher sein.`,
                moneyComputedTip: "Die Menge an Münzen, die pro Tag produziert wird (beinhaltet Antike Wunder, die Münzen produzieren)",
                moneyUsedComputedTip: "Die Menge an Münzen, die für die Produktion von Gütern benötigt wird",
                moneyRemainingComputedTip: "Münzen - Münzen benötigt, ist der Überschuss bzw. das Defizit an Münzen, den/das ein Spieler jeden Tag haben wird",
                suppliesComputedTip: `Die Menge an Vorräten, die hergestellt werden würde, wenn alle Werkstätten 1x24std (Werkzeugkiste) produzieren + das, was durch Antike Wunder eingenommen wird (Set-Gebäude ausgenommen)`,
                suppliesUsedComputedTip: `Die Menge an Vorräten, die für die Produktion von Gütern benötigt wird. Beinhaltet NICHT die Vorräte, die für die Produktion in den Kasernen gebraucht wird! Siehe Erklärung oben`,
                suppliesRemainingComputedTip: `Vorräte - Vorräte benötigt, ist der Überschuss bzw. das Defizit an Vorräten, den/das ein Spieler jeden Tag haben wird`,
                manaTip: "Die Menge an Mana, die innerhalb von 24 Std. produziert wird (Drachenkloster ausgenommen)",
            },
            popCultureTable: {
                heading: "Bevölkerungs-/Kultur-Details",
                description: `Die unten stehende Tabelle zeigt die Bevölkerung/Kultur für jedes Mitglied an. Fahre mit der Maus über die 
                Spaltenüberschriften, um weitere Informationen zu erhalten.`,

                // Icon Sub-Headings
                minBoostPercent: "min K.-Bonus %",
                levels: "Ausbaustufen",
                total: "gesamt",
                working: "arbeitend",
                available: "verfügbar",
                required: "benötigt",

                // Low Priority - Tool Tips
                wonderLevelsTip: "Die Gesamtanzahl der Ausbaustufen der Antiken Wunder, die ein Spieler hat",
                cultureBoostPercentTip: `Der Kulturbonus-Prozentsatz.  WICHTIG: dieser wird in der Annahme berechnet, dass KEINE NACHBARSCHAFTSHILFE 
                erhalten wurde. In Wirklichkeit wird der Kulturbonus in den Städten aber voraussichtlich höher sein.`,
                totalPopulationTip: "Gesamtbevölkerung, produziert durch Wohngebäude, Hybrid-Gebäude (Kultur & Bevölkerung) und Antike Wunder",
                workingPopulationTip: "Arbeitende Bevölkerung - die von Gebäuden verbrauchte Menge ",
                availablePopulationTip: "Verfügbare Bevölkerung",
                totalCultureTip: "Gesamtkultur, produziert durch Kulturgebäude, Hybrid-Gebäude (Kultur & Bevölkerung) und Antike Wunder",
                requiredCultureTip: "Benötigte Kultur für alle deine Gebäude",
                availableCultureTip: "Verfügbare Kultur",
            },
            cityCoverageTable: {
                heading: "Flächennutzung",
                description: "Zeigt an, wie viele Felder in der Stadt eines jeden Mitgliedes für den jeweiligen Gebäudetyp benutzt werden. Leere Felder sind Felder, die zurzeit nicht benutzt werden.",
                tiles: 'Felder'
            },

            // HIGH PRIORITY TO TRANSLATE
            weeklyReport: {
                heading: `Wöchentlicher E-Mail-Report`,
                description: `Wir stellen automatisch generierte Wochenreporte zur Verfügung, die sich für den Austausch mit deinen 
                Gemeinschaftsmitgliedern eignen. Jeden Sonntag (schätzungsweise gegen 8pm UTC) ist ein neuer Wochenreport für die vergangene Woche
                verfügbar. Kopiere einfach den unten stehenden Text und füge ihn ein!`,
                selectReportHint: "Wähle einen Report für die Woche endend am s. o. aus",
                reportsAreOptimizedFor: `E-Mail-Reports sind für die Anzeige im Nachrichtensystem von Elvenar optimiert, so dass die Spalten richtig 
                ausgerichtet sind und Benutzernamen gekürzt werden, damit alles in eine Nachricht passt.`,
                accolades: "Auszeichnungen",
                tourneyChamp: " - Turniersieger (diese Woche): {0}",
                tourneyHero: " - Turnierheld (letzte 4 Wochen): {0}",
                highestGrowthPlusPercentage: " - Höchstes Wachstum (Punkte & Prozentsatz): {0}",
                highestGrowthPoints: " - Höchstes Wachstum (Punkte): {0}",
                highestGrowthPercentage: " - Höchstes Wachstum (Prozentsatz): {0}",
                highestGrowthError: " - Höchstes Wachstum: Kann noch nicht festgestellt werden, es werden mehr Daten benötigt",
                newPersonalRecords: "Neue persönliche Rekorde",
                userSetANewPersonalRecordFor: " * {0} hat einen neuen Rekord aufgestellt für: {1}",
                allMembersByPointGainThisWeek: "ALLE MITGLIEDER nach Punkte-/Prozentsatz-Zuwachs (diese Woche)",
                tournamentPointsHeader: "TURNIERPUNKTE (diese Woche/GESAMT seit {0})",
                top8ByPercentage: "TOP 8 nach Prozentsatz (diese Woche)",
                top8ByPointsSince: "TOP 8 nach Punkten (Seit {0})",
                top8ByPercentageSince: "TOP 8 nach Prozentsatz (Seit {0})",
                reportGeneratedBy: "Report generiert von elvenstats.com, für weitere Informationen siehe: ",
                mostPointsInAWeek: "Meiste Punkte in einer Woche",
                highestTournamentScore: "Höchste Turnierpunktzahl",
                highestTournamentRank: "Höchster Turnierrang",
                insufficientHistoryForThesePlayers: "* Ausgelassen: {0} wegen unzureichender Historie.  Sie werden nächste Woche mit dabei sein",
                insufficientHistory1Week: "* Unzureichende Historie für diesen Bereich. Schaue nächste Woche wieder vorbei!",
                insufficientHistory4Weeks: "* Unzureichende Historie für diesen Bereich. Es werden 4 Wochen Historie benötigt. Schaue demnächst wieder vorbei!",
            },
            memberHistory: {
                heading: "Mitglieder-Historie",
                noChangesDetected: "Keine Mitgliederänderungen seit Beginn der Nachverfolgung der Gemeinschaft festgestellt auf {0}"
            },
            // Medium Priority
            notifications: {
                unsavedChanges: 'Es wurden ungesicherte Änderungen festgestellt. Klicke nach Beenden der Änderungen deiner Gemeinschaft auf den Speicher-Button.',
                standbyImporting: 'Bitte warten: Wir importieren fehlende Informationen einiger Mitglieder',
                limitedHistory: "Wir haben erst vor Kurzem damit begonnen, {0} zu verfolgen, dementsprechend gibt es eine eingeschränkte Historie.  Jeden Sonntag erscheinen hier wöchentliche Snapshots also schaue bald wieder vorbei!",
                noChangesSinceTrackingBegan: "Keine Änderungen seit Beginn der Nachverfolgung festgestellt",
            }
        },
        player: {
            fellowshipHistory: {
                heading: "Gemeinschaftshistorie"
            }
        },
        status: {
            realTimeUpdatesNotAvailableHeadline: "Echtzeit-Updates sind zurzeit nicht verfügbar.",
            realTimeUpdatesNotAvailableDescription: "Dies geschieht in der Regel, nachdem die Elvenar Spieleserver neu gestartet wurden, um ein Update zu installieren oder um Wartungen durchzuführen.  Sobald dies der Fall ist, muss sich ElvenStats manuell bei allen Spieleservern anmelden, bevor Informationen wieder auf Anfrage abrufbar sind.  Bitte wiederhole deine Anfrage in ein paar Stunden.  Währenddessen ist die Seite vollständig funktionsfähig.",
            copyToClipboardSuccessful: "Kopieren in die Zwischenablage erfolgreich!",
            copyToClipboardFailed: "Kopieren fehlgeschlagen, markiere den gesamten Textbereich und drücke Strg+C",
            errorOccurredImporting: "Fehler aufgetreten beim Importieren der Benutzer.",
            errorOccurredImportingMessage: "Beim Importieren der Benutzer ist ein Fehler aufgetreten.  Bitte versuche es erneut.  Wenn der Fehler weiterhin besteht, kontaktiere uns bitte.",
            errorOccurredImportingWillNotBeAvailableInReports: "Benutzer, die nicht importiert wurden, werden nicht mit in die Berichte aufgenommen.",
            finishedSyncSuccessful: "Abgeschlossen, Synchronisation war erfolgreich!",
            playerIsAnonymous: "Der Spieler hat beantragt, dass seine Daten nicht auf elvenstats.com zu sehen sind.",
            inactiveWarningTip: "Dieser Spieler ist möglicherweise inaktiv.  Letzte Änderung des Punktestandes: {0}",
            isFriendTip: "Dieser Spieler ist ein Freund von ElvenStats.  Er hat entweder seine Zeit investiert oder Geld gespendet, um die Seite zu unterstützen!",
        },
    }
}


// WEBPACK FOOTER //
// ./src/lang/de.js